import React from 'react'

const Textarea = ({
  label,
  width,
  value,
  onChange,
  placeholder,
  readOnly,
  error,
  required,
  ...props
}) => {
  return (
    <div className="textfield-wrapper" style={{ width }}>
      {label && (
        <label className="textfield-label">
          {label}
          {required && <span className="req">*</span>}
        </label>
      )}
      <textarea
        className={`textfield-input ${error ? 'textfield-error' : ''}`}
        value={value}
        onChange={onChange}
        rows="4"
        readOnly={readOnly}
        placeholder={placeholder}
        {...props}
      />
    </div>
  )
}

export default Textarea
